import React, {useState, useEffect} from 'react'
import './transHist.style.css'
import './transHisDe.style.css'
import Overlay from '../../components/Overlay';
import { NhealthAction } from '../../_actions/action.api'
import axios from 'axios';
import { useParams } from 'react-router-dom'
//! Line Liff
import liff from '@line/liff'
// Mockup Data
// import TransHisData from '../../utils/JSON/transHisMock.json'
// import TransHisDetailsData from '../../utils/JSON/transHisDetailsMock.json'
import HistoryDetails from '../../utils/JSON/hisdetails.json'
// Components
import TransHisDetailsCard from '../../components/TransHisCardDetails';
import { DecryptedOBJ } from '../../utils/Encryption';


function AppointHistoryDetails(props) {

    const [openDetail, setOpenDetail] = useState(false);
    const [hisData, setHisData] = useState(null);

    const lineProfile = DecryptedOBJ(window.localStorage.getItem('line_profile'));
    const { tranid } = useParams();

    useEffect(() => {
        // Init Data
        hisDetailsDataInit()
    },[])

    const onSelect = (tranId) => {
        // Fetch Transaction History Details
        let reqData = {
            line_user: lineProfile.user_id,
            line_token: lineProfile.id_token,
            tranid: tranId
        }
    }

    const hisDetailsDataInit = () => {
        // let reqData = {
        //     line_user: lineProfile.user_id,
        //     tranid: tranid 
        // }        

        // For Publish
        // NhealthAction.GetHistoryAppoint(reqData)
        // .then(res => {
        //     // console.log('Get History Appoint: ', res)
        //     if(res.isSuccess === true)
        //     {
        //         setHisData(res.appointlist); 
        //     }else
        //     {
        //         setHisData([]); 
        //     }
        // })
    }

    return (
        <div className="transhis-con">
            {/* Content Wrap */}
            <div className="transhis-wrap">
                {/* Back button */}
                <a className="transhis-backbutton" href="/lab/n-health/appointHistory"><i className="bi bi-chevron-left"></i> ย้อนกลับ</a>
                {/* Title */}
                <h1 className="header">ข้อมูลการทำนัด</h1>
                {/* Transactions List */}

                {/* - For Prod */}
                {/* {hisData !== null
                    ? 
                        hisData.map((item, i) => 
                            <TransHisDetailsCard key={i} onSelect={onSelect} data={item} tranid={tranid} />
                        )
                    :   <div className="his-notfound">ไม่พบข้อมูล</div>
                } */}
                
                {/* For Dev */}
                {HistoryDetails.tracking.map((item, i) => 
                    <TransHisDetailsCard key={i} onSelect={onSelect} status={item.strstatus} packagedata={HistoryDetails.detail[i]} data={HistoryDetails.history} />
                )}
            </div>
            {/* overlay */}
            <Overlay 
                openDetail={openDetail} 
                setOpenDetail={setOpenDetail}
            />
        </div>
    )
}

export default AppointHistoryDetails;